import type { VoucherHook } from "@/types/centra";

import Input from "../Input";
import styles from "./vouchers.module.css";

const UI = (props: { voucher: VoucherHook }) => {
  const { voucher } = props;
  const { code, add, remove, showRemove, error, updateCode, isValid } = voucher;
  if (showRemove)
    return (
      <div className={styles.container}>
        <span className={styles.subContainer}>
          <p>Voucher </p>
          <p>
            <strong>{code}</strong>
          </p>
        </span>
        <span className={styles.subContainer}>
          <span />
          <button onClick={remove} className={styles.button}>
            Remove
          </button>
        </span>
      </div>
    );
  return (
    <section className={styles.container}>
      <span className={styles.row}>
        <p>Have a voucher?</p>
        {error && <p className={styles.error}>{error}</p>}
      </span>
      <form className={styles.form} onSubmit={add}>
        <input
          className={styles.input}
          placeholder="Voucher code"
          value={code}
          onChange={updateCode}
        />
        <input
          className={styles.button}
          type="submit"
          value="Apply"
          disabled={!isValid}
        />
      </form>
    </section>
  );
};

export default UI;
